import script from "./LineMessagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./LineMessagePreview.vue?vue&type=script&setup=true&lang=js"

import "./LineMessagePreview.vue?vue&type=style&index=0&id=282c24fd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-282c24fd"]])

export default __exports__